// XXX: @noflow <- because flow can’t do `import()` yet:
// https://github.com/facebook/flow/issues/2968

import {scriptUrl} from "../environment.js";

if (IS_BROWSER) {
	__webpack_public_path__ = scriptUrl;
}

export default function load() {
	return import("./index.js");
}



// WEBPACK FOOTER //
// ./lib/pagehandler/load.js